import { useSelector } from 'react-redux';
import { useLocalStorage } from '../../../../../../helpers/storage';

export const draftName = 'createShutdownDraft';

export const useDraftLocalStorage = () => {
  const { WorkerId } = useSelector((state) => state.authentication.userInfo);
  return useLocalStorage(`${draftName}_${WorkerId}`);
};
